<template>
  <div>
    <b-row class="py-3 px-2 mx-1 bg-white rounded">
      <b-col cols="3" class="text-left">
        <b-button
          variant="danger"
          @click="$emit('back-to-application-admin')"
          pill
          class="ml-1"
        >
          <v-icon name="arrow-left" /> Volver
        </b-button>
      </b-col>
      <b-col>
        <b-form-select v-model="selectedStudentLevel" @change="changeLevel">
          <b-form-select-option :value="''" disabled>
            Seleccione un Nivel
          </b-form-select-option>
          <b-form-select-option v-if="levels.length == 0" disabled>
            No hay estudiantes en esta aplicación
          </b-form-select-option>
          <b-form-select-option
            v-for="(level, levelIdx) in levels"
            :key="levelIdx"
            :value="level"
          >
            {{ level.label }}
          </b-form-select-option>
        </b-form-select>
      </b-col>

      <b-col>
        <b-form-select v-model="selectedStudentsGrade" @change="changeGrade">
          <b-form-select-option :value="null" disabled>
            Seleccione un Curso
          </b-form-select-option>
          <b-form-select-option
            v-for="(grade, gradeIdx) in loadedLevels[selectedStudentLevel.code]"
            :key="gradeIdx"
            :value="grade"
          >
            {{ selectedStudentLevel.label + " " + grade.name }}
          </b-form-select-option>
        </b-form-select>
      </b-col>

      <b-col>
        <b-form-select v-model="selectedStudentLink" @change="changeStudent">
          <b-form-select-option :value="null" disabled>
            Seleccione un Estudiante
          </b-form-select-option>
          <b-form-select-option
            v-for="(student, studentIdx) in selectedStudents"
            :key="studentIdx"
            :value="student.material_link"
          >
            {{ student.material_link.student_name }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
    </b-row>
    <div class="bg-white mt-2 mx-1 rounded">
      <b-tabs
        v-model="activeTab"
        content-class="p-0"
        fill
        align="center"
        card
        justified
      >
        <b-tab title="Ver el Material" lazy>
          <material-preview
            :inMaterial="{ id: selectedApplication.material.id }"
            mode="checkingApplication"
          />
        </b-tab>
        <b-tab title="Corregir Aplicación">
          <div v-if="selectedStudentLink">
            <material-response-review
              v-if="selectedStudentLink.finished"
              :key="renderResponseKey"
              :reviewResponseID="
                selectedStudentLink ? selectedStudentLink.id : null
              "
              :selectedLink="selectedStudentLink ? selectedStudentLink : null"
              @back="$emit('back')"
            />
            <div v-else>
              <p class="text-warning">
                ESTE ESTUDIANTE NO HA RESPONDIDO EL MATERIAL
              </p>
            </div>
          </div>
          <div v-else>
            <p class="text-warning">SELECCIONE UN ESTUDIANTE</p>
          </div>
        </b-tab>
        <b-tab title="Ver Informe">
          <div v-if="!reportLink">
            <p class="text-warning">
              NO SE HA GENERADO INFORME PARA ESTE ESTUDIANTE
            </p>
            <div class="text-center mt-3" v-if="selectedStudentLink && selectedStudentLink.finished && selectedStudentLink.reviewed">
              <b-button 
                variant="info" 
                pill 
                @click="generateReport"
                :disabled="generatingReport"
              >
                <b-spinner small v-if="generatingReport"></b-spinner>
                {{ generatingReport ? 'Generando...' : 'Generar Informe' }}
              </b-button>
            </div>
            <div v-if="selectedStudentLink && (!selectedStudentLink.finished || !selectedStudentLink.reviewed)" class="text-center mt-3">
              <p class="text-muted">
                <small>
                  El estudiante debe completar y el material debe estar revisado para generar el informe.
                </small>
              </p>
            </div>
          </div>
          <div v-else>
            <div class="text-right">
              <b-button @click="downloadReport">Descargar Informe</b-button>
            </div>
            <b-embed
              :src="reportLink"
              type="iframe"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              aspect="21by9"
            />
          </div>
        </b-tab>
        <b-tab title="Ingresar Puntajes">
          <div v-if="selectedStudentLink">
            <manual-score-entry
              :materialLinkId="selectedStudentLink.id"
              @scores-saved="handleScoresSaved"
            />
          </div>
          <div v-else>
            <p class="text-warning text-center py-5">SELECCIONE UN ESTUDIANTE</p>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import customMaterialService from "@/services/customMaterialService";
import MaterialResponseReview from "@/components/custom-materials/miscellaneous/MaterialResponseReview";
import MaterialPreview from "@/components/custom-materials/miscellaneous/MaterialPreview";
import ManualScoreEntry from "@/components/custom-materials/miscellaneous/ManualScoreEntry";
import api from "@/services/api";

export default {
  name: "MaterialResponseAdmin",
  components: {
    MaterialResponseReview,
    MaterialPreview,
    ManualScoreEntry,
  },
  props: {
    selectedLink: {
      type: Object,
      required: false,
    },
    application: {
      type: Object,
      required: false,
    },
    levels: {
      type: Array,
      required: false,
    },
    selectedLevel: {
      type: Object,
      required: false,
    },
    selectedGrade: {
      type: Object,
      required: false,
    },
    openDirectlyInManualScore: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    // this.selectedGrade = this.selectedLink.student_grade.grade;
    this.selectedApplication = this.application;
    this.selectedStudentLink = this.selectedLink;
    this.selectedStudentLevel = this.selectedLevel;
    this.selectedStudentsGrade = this.selectedGrade;
    this.selectedStudents = this.selectedGrade.students;
    this.$options.sockets.onmessage = (data) => {
      const message = JSON.parse(data.data);
      if (message.type === "report_file_updated") {
        if (message.material_link.id == this.selectedStudentLink.id) {
          this.reportLink = message.material_file.alternate_link;
          this.downloadLink = message.material_file.download_link;
          this.activeTab = 2;
          this.$toasted.success("Informe creado!");
        }
      }
    };
  },
  data() {
    return {
      selectedApplication: {},
      // selectedGrade: "",
      selectedStudentLink: null,
      selectedStudentLevel: null,
      // applications:[],
      renderResponseKey: 0,
      reportLink: "",
      downloadLink: "",
      activeTab: this.openDirectlyInManualScore ? 3 : 1,
      loadedLevels: {},
      selectedStudentsGrade: null,
      selectedStudents: [],
      generatingReport: false,
    };
  },
  computed: {
    schoolID() {
      return this.$store.state.login.school;
    },
    userID() {
      return this.$store.state.login.user_id;
    },
  },
  watch: {},
  mounted() {
    this.retrieveReportLink();
    this.load(this.selectedLevel.code);
  },
  methods: {
    renderingResponseKey() {
      this.renderResponseKey += 1;
    },

    changeStudent() {
      this.renderingResponseKey();
      this.retrieveReportLink();
    },
    changeLevel(newVal) {
      this.selectedStudentLink = null;
      this.selectedStudentsGrade = null;
      this.selectedStudents = [];

      !this.loadedLevels[newVal.code] ? this.load(newVal.code) : "";
    },
    retrieveReportLink() {
      customMaterialService
        .getApplicationReport(this.selectedStudentLink.id)
        .then((response) => {
          this.reportLink = response.alternate_link;
          this.downloadLink = response.download_link;
        })
        .catch((e) => {
          console.log(e);
          this.reportLink = "";
        });
    },
    downloadReport() {
      const link = document.createElement("a");
      link.href = this.downloadLink;

      link.setAttribute("download", "file.docx");
      document.body.appendChild(link);
      link.click();
    },
    generateReport() {
      if (!this.selectedStudentLink || !this.selectedStudentLink.student_grade) {
        this.$toasted.error("No se pudo obtener la información del estudiante");
        return;
      }

      this.generatingReport = true;
      
      const payload = {
        student_grade: this.selectedStudentLink.student_grade.id,
        material: this.selectedApplication.material.id,
        material_link: this.selectedStudentLink.id
      };

      // TEMPORAL: Descarga directa del informe sin subir a Drive
      api.post("schools/create_material_report/", payload, {
        responseType: 'blob'
      })
        .then((response) => {
          console.log('[INFORME FRONTEND] ===== DESCARGA INICIADA =====');
          console.log('[INFORME FRONTEND] Tipo de response.data:', typeof response.data);
          console.log('[INFORME FRONTEND] Es blob:', response.data instanceof Blob);
          console.log('[INFORME FRONTEND] Tamaño del blob:', response.data.size, 'bytes');
          
          // response.data ya es un blob cuando se usa responseType: 'blob'
          const blob = response.data;
          
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          
          // Extraer nombre del header Content-Disposition
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'Informe_Material.docx';
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
              filename = filenameMatch[1];
              console.log('[INFORME FRONTEND] Nombre del archivo extraído:', filename);
            }
          }
          
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          
          // Limpiar
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          
          console.log('[INFORME FRONTEND] Descarga completada:', filename);
          console.log('[INFORME FRONTEND] ===== FIN DESCARGA =====');
          
          this.$toasted.success('Informe descargado exitosamente');
        })
        .catch((error) => {
          console.error('Error generando informe:', error);
          this.$toasted.error('Error al generar el informe');
        })
        .finally(() => {
          this.generatingReport = false;
        });
    },
    load(level) {
      this.$set(this.loadedLevels, level, null);
      customMaterialService
        .getLevelLinks(this.selectedApplication.id, level)
        .then((data) => {
          this.$set(this.loadedLevels, level, data.grades);
        });
    },
    changeGrade(newVal) {
      this.selectedStudentLink = null;
      this.selectedStudents = newVal.students;
    },
    handleScoresSaved() {
      // Actualizar el estado del material link para reflejar que está iniciado, terminado y revisado
      if (this.selectedStudentLink) {
        this.selectedStudentLink.started = true;
        this.selectedStudentLink.finished = true;
        this.selectedStudentLink.reviewed = true;
      }
      // Forzar re-renderizado de la pestaña de corrección
      this.renderingResponseKey();
      this.$toasted.success('Puntajes guardados exitosamente');
    },
  },
};
</script>

<style></style>